import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=16c038fa&"
import script from "./Terms.vue?vue&type=script&lang=js&"
export * from "./Terms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports